import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";

export const selectAdmonCatalogoState = (state: AppState) =>
  state.admonCatalogos;
export const selectCatalogoUsuuarioStatus = createSelector(
  selectAdmonCatalogoState,
  (state) => state.usuarios
);
export const selectCatalogoRemitenteStatus = createSelector(
  selectAdmonCatalogoState,
  (state) => state.remitentes
);
export const selectCatalogoEmpresaStatus = createSelector(
  selectAdmonCatalogoState,
  (state) => state.empresas
);
export const selectCatalogoModoStatus = createSelector(
  selectAdmonCatalogoState,
  (state) => state.modosEntrada
);
export const selectCatalogoTipooStatus = createSelector(
  selectAdmonCatalogoState,
  (state) => state.tipos
);
